import * as api from "../../../../services/api";

export const GET_USERS = "GET_USERS";
export const GET_USERS_SUCCESS = "GET_USERS_SUCCESS";
export const GET_USERS_FAILED = "GET_USERS_FAILED";

export const GET_DRIVERS = "GET_DRIVERS";
export const GET_DRIVERS_SUCCESS = "GET_DRIVERS_SUCCESS";
export const GET_DRIVERS_FAILED = "GET_DRIVERS_FAILED";

export const SET_VALUE = "[USER REPORT] SET_VALUE";

export function getUsers(callback) {
	return async (dispatch, getState) => {
		dispatch({
			type: GET_USERS
		});

		const { token } = getState().login;

		let response = await api.sendGet("/user", {
			Authorization: "Bearer " + token
		});
		if (response.ok) {
			let json = await response.json();
			let users = json.model;

			dispatch({
				type: GET_USERS_SUCCESS,
				payload: users
			});

			callback && callback(null, users);
		} else {
			dispatch({
				type: GET_USERS_FAILED
			});
			callback && callback(true);
		}
	};
}

export function getDrivers(callback) {
	return async (dispatch, getState) => {
		dispatch({
			type: GET_DRIVERS
		});

		const { token } = getState().login;

		let response = await api.sendGet("/user/driver", {
			Authorization: "Bearer " + token
		});
		if (response.ok) {
			let json = await response.json();
			let users = json.model;

			dispatch({
				type: GET_DRIVERS_SUCCESS,
				payload: users
			});

			callback && callback(null, users);
		} else {
			dispatch({
				type: GET_DRIVERS_FAILED
			});
			callback && callback(true);
		}
	};
}

export function getUsersV2(
	skip,
	take,
	filter,
	sort,
	desc,
	toExport,
	callback
) {
	return async (dispatch, getState) => {
		dispatch({
			type: GET_USERS
		});

		const { login } = getState();
		const { token } = login;

		let response = await api.sendGet(
			`/user/v2?skip=${skip}&take=${take}&sort=${sort}&desc=${desc}${filter || ""}`,
			{
				Authorization: "Bearer " + token
			}
		);

		if (response.ok) {
			let result = await response.json();

			if (result.isValid) {
				if (toExport) {
					dispatch(setValue({ loading: false }));
				} else {
					dispatch({
						type: GET_USERS_SUCCESS,
						payload: result.model
					});

					if (result.params)
						dispatch(
							setValue({
								pages: Math.ceil(result.params.count / take),
								...result.params
							})
						);
				}

				callback && callback(null, result.model);
			} else {
				dispatch({ type: GET_USERS_FAILED, payload: result.errors });
				callback && callback(result.errors, result.model);
			}
		} else {
			dispatch({ type: GET_USERS_FAILED });
			callback && callback("Ocorreu um erro ao tentar carregar os usuários");
		}
	};
}

export function setValue(payload) {
	return {
		type: SET_VALUE,
		payload
	};
}
